import ChartTable from './components/chartTable';
import Vue from 'vue';

/**
 * @param chartTable {Element}
 *
 * @returns {*}
 */
function initChartTable(chartTable) {
    new Vue({
        el: '#statTable',
        render(createElement) {
            return createElement(ChartTable);
        },
    });
}

export { initChartTable };
